module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-Bold.ae1bf5a.woff";